import { create, METHOD } from '../utils'

// 声明一个类型
export declare type TableType = "thtt_cloud_params";

export default {

    /** 匹配 */
    match: (props: {
        scope: string,
        type: number,
        demandType: string,
        resultType: string,
        assets: string,
        capital: string,
        technology: string,
        business: string,
        economic_circle: string,
        country: string,
        org_type: string,
        region: string,
    }) => create({
        url: "/egg/match/match",
        method: METHOD.GET
    })(props),

    /** 匹配 */
    matchByMyData: (props: {
        user_id: string,
    }) => create({
        url: "/egg/match/matchByMyData",
        method: METHOD.GET
    })(props),

    /** 推送 */
    pushToSubUser: (props: {
        userId: string,
    }) => create({
        url: "/egg/match/pushToSubUser",
        method: METHOD.POST
    })(props),

    /** 推送 */
    pushToSubUserServer: (props: {
        userId: string,
    }) => create({
        url: "/eggServer/egg/match/pushToSubUser",
        method: METHOD.POST
    })(props),

}